import { Activity } from "@ofqual/portal-activity-feed";
import { ActivityType } from "../../../domain/ActivityType";
import { EventNotification } from "../../../domain/EventNotification";
import { AttachDialog } from "./dialogs/AttachDialog";
import { MessageDialog } from "./dialogs/MessageDialog";
import { UpdatedDialog } from "./dialogs/UpdatedDialog";
import { ActionType } from "./EventNotificationActivityFeedTypes";

export const renderDialog = (
  eventNotification: EventNotification | null,
  focussedEntity: ActionType | Activity | null,
  onClose: () => void
) => {
  if (!focussedEntity) {
    return;
  }

  const activity = focussedEntity as Activity;
  const actionType = focussedEntity as ActionType;

  if (activity && activity.activityType) {
    switch (activity.activityType) {
      case ActivityType.EventNotificationAoDetailsUpdated:
      case ActivityType.EventNotificationOfqualDetailsUpdated:
        return <UpdatedDialog activity={activity} onClose={onClose} />;
      default:
        return null;
    }
  } else {
    switch (actionType) {
      case ActionType.SendMessage:
        return (
          <MessageDialog
            eventNotification={eventNotification!}
            onClose={onClose}
          />
        );
      case ActionType.AttachDocument:
        return (
          <AttachDialog
            eventNotification={eventNotification!}
            onClose={onClose}
          />
        );
      default:
        return null;
    }
  }
};
